module.exports = __webpack_public_path__ + "img/21@2x.c50abe33.png";